/** @format */

import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface cookieDescriptors {
  title: string;
  paragraph: string;
  link: string;
  button: string;
}

export interface CookieState {
  allowCookies: boolean;
  status: "idle" | "loading" | "failed";
}

const initialState: CookieState = {
  allowCookies: false,
  status: "idle",
};

export const createCookie = createAsyncThunk(
  "cookie/addCookie",
  async (allowCookies: boolean) => {
    window.localStorage.setItem("allowCookies", `${allowCookies}`);
    return allowCookies;
  },
);

export const cookieSlice = createSlice({
  name: "cookie",
  initialState,
  reducers: {
    setAllowCookies: (state, action: PayloadAction<boolean>) => {
      state.allowCookies = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCookie.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createCookie.fulfilled, (state, action) => {
        state.allowCookies = action.payload;
        state.status = "idle";
      })
      .addCase(createCookie.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { setAllowCookies } = cookieSlice.actions;
export const selectAllowCookies = () => (state: RootState) =>
  state.cookie.allowCookies;

export default cookieSlice.reducer;
